import { Link } from "react-router-dom";

const footerLinks = [
  { label: "브랜드", to: "/brand" },
  { label: "제품소개", to: "/products" },
  { label: "프로젝트", to: "/projects" },
  { label: "회사소개", to: "/about" },
  { label: "고객문의", to: "/contact" },
  { label: "NOTICE", to: "/notice" },
];

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-accent-900">
                <i className="ri-layout-masonry-line text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-bold">동우스톤</span>
                <span className="font-label text-[9px] tracking-[0.28em] opacity-70">DONGWOO STONE</span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-200/80">
              천연석부터 엔지니어드 스톤, 포세린까지. 공간에 오래 남는 소재를 큐레이션합니다.
            </p>
          </div>

          <div>
            <h4 className="font-label text-xs font-semibold tracking-[0.2em] text-background-200/70">바로가기</h4>
            <ul className="mt-5 grid grid-cols-2 gap-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-sm text-background-100/90 transition-colors hover:text-primary-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs font-semibold tracking-[0.2em] text-background-200/70">서울 본사</h4>
            <ul className="mt-5 space-y-3 text-sm text-background-100/90">
              <li className="flex gap-2.5">
                <i className="ri-map-pin-line mt-0.5 shrink-0 text-base text-primary-200" />
                <span>서울특별시 강동구 성내로 19, 6층 일신석재</span>
              </li>
              <li className="flex gap-2.5">
                <i className="ri-phone-line mt-0.5 shrink-0 text-base text-primary-200" />
                <span>T. 02-487-9009</span>
              </li>
              <li className="flex gap-2.5">
                <i className="ri-printer-line mt-0.5 shrink-0 text-base text-primary-200" />
                <span>F. 02-477-5278</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs font-semibold tracking-[0.2em] text-background-200/70">부산 전시장</h4>
            <ul className="mt-5 space-y-3 text-sm text-background-100/90">
              <li className="flex gap-2.5">
                <i className="ri-map-pin-line mt-0.5 shrink-0 text-base text-primary-200" />
                <span>부산광역시 해운대구 달맞이길 120-30, 5층</span>
              </li>
              <li className="flex gap-2.5">
                <i className="ri-phone-line mt-0.5 shrink-0 text-base text-primary-200" />
                <span>T. 051-741-2045</span>
              </li>
              <li className="flex gap-2.5">
                <i className="ri-time-line mt-0.5 shrink-0 text-base text-primary-200" />
                <span>평일 09:30 - 18:00 / 토 10:00 - 15:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p>Copyright © 동우스톤 All rights reserved.</p>
          <p className="flex flex-wrap gap-x-4 gap-y-2">
            <span>사업자등록번호 214-81-94289</span>
            <span>대표 홍길동</span>
            <span className="cursor-pointer transition-colors hover:text-background-50">개인정보처리방침</span>
          </p>
        </div>
      </div>
    </footer>
  );
}